import styled from 'styled-components'

interface CuriosityContainerProps {
  img: string
}

export const CuriosityContainer = styled.div<CuriosityContainerProps>`
  background: url(${props => props.img}) no-repeat;

  .content {
    width: 90%;
  }

  .text {
    background-color: rgba(31, 26, 62, 0.9);
    color: var(--light);
    border-radius: 0.3125rem;
    padding: 2rem;

    h3 {
      font-weight: bold;
      font-size: 18px;
      margin-bottom: 1rem;
    }

    p {
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
    }
  }
`
